module.exports = __webpack_public_path__ + "img/ROT_ETL.5a237f42.png";